<template>
  <div>
    <div class="p-3">
      <div class="breadcrumb-area pos-relative w-100">
        <h1>Tạo phiếu thu đối tác</h1>
        <div class="btn-group float-right">
          <button
            type="button"
            class="font-medium btn btn-outline-secondary"
            @click="$router.push(`/order-form-detail/${id}`)"
          >
            <i class="bx bx-arrow-back"></i> Quay lại
          </button>
          <button class="btn font-medium btn-primary" @click="saveData">
            <i class="bx bx-save"></i><span>&nbsp;</span>Lưu
          </button>
        </div>
      </div>
      <div class="p-10 pt-15 b-t-1-869fb229">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-detail card p-4">
              <!-- <div class="form-group form-row">
                <label for="amount" class="col-sm-3 col-form-label">
                  Số tiền <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <input id="amount" v-model="formData.amount" type="text" class="form-control"
                    :class="{ 'is-invalid': validationErrors.amount }" @input="validateAmount" @keypress="numberOnly" />
                  <div v-if="validationErrors.amount" class="invalid-feedback">
                    {{ validationErrors.amount }}
                  </div>
                </div>
              </div> -->

              <div class="form-group form-row">
                <label for="appendix-code" class="col-sm-3 col-form-label">
                  Mã phụ lục <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <input
                    id="appendix-code"
                    v-model="formData.appendixCode"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.appendixCode }"
                  />
                  <div v-if="validationErrors.appendixCode" class="invalid-feedback">
                    {{ validationErrors.appendixCode }}
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="receipt-date" class="col-sm-3 col-form-label"> Ngày thu tiền </label>
                <div class="col-sm-9">
                  <div class="date-picker-wrapper position-relative">
                    <input
                      id="receipt-date"
                      v-model="formData.receiptDate"
                      type="date"
                      class="form-control"
                      :class="{ 'is-invalid': validationErrors.receiptDate }"
                      @click="openDatePicker"
                      ref="dateInput"
                    />
                    <i
                      class="bx bx-calendar position-absolute"
                      style="right: 10px; top: 10px; cursor: pointer"
                      @click="openDatePicker"
                    ></i>
                    <div v-if="validationErrors.receiptDate" class="invalid-feedback">
                      {{ validationErrors.receiptDate }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="transaction-code" class="col-sm-3 col-form-label"> Mã giao dịch </label>
                <div class="col-sm-9">
                  <input
                    id="transaction-code"
                    v-model="formData.transactionCode"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.transactionCode }"
                  />
                  <div v-if="validationErrors.transactionCode" class="invalid-feedback">
                    {{ validationErrors.transactionCode }}
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="description" class="col-sm-3 col-form-label"> Ghi chú </label>
                <div class="col-sm-9">
                  <textarea
                    id="description"
                    v-model="formData.description"
                    class="form-control"
                    :class="{ 'is-invalid': validationErrors.description }"
                    rows="3"
                  ></textarea>
                  <div v-if="validationErrors.description" class="invalid-feedback">
                    {{ validationErrors.description }}
                  </div>
                </div>
              </div>

              <!-- TEMPLATE - Thay thế phần đơn giá hiện tại -->
              <div class="form-group form-row my-4">
                <label for="unit-price" class="col-sm-3 col-form-label"> Đơn giá </label>
                <div class="col-sm-9">
                  <div
                    v-for="(item, index) in dataDetail.orderDetail"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      margin-bottom: 10px;
                    "
                    :key="index"
                  >
                    <p style="margin: 0; min-width: 150px">{{ item?.categoryName }}</p>
                    <p style="margin: 0; min-width: 80px; text-align: center">
                      Số lượng: {{ item?.quantity }}
                    </p>
                    <div style="min-width: 100px">
                      <input
                        :id="`unit-price-${index}`"
                        v-model="item.unitPrice"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': validationErrors[`unitPrice_${index}`] }"
                        @input="validateUnitPrice(index)"
                        @keypress="numberOnly"
                        placeholder="Nhập đơn giá (không bắt buộc)"
                      />
                      <div v-if="validationErrors[`unitPrice_${index}`]" class="invalid-feedback">
                        {{ validationErrors[`unitPrice_${index}`] }}
                      </div>
                    </div>
                  </div>

                  <!-- Hiển thị tổng -->
                  <div class="total-section mt-3 pt-3 border-top">
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-weight: bold;
                        font-size: 13px;
                      "
                    >
                      <span>Tổng cộng:</span>
                      <span class="text-primary">{{ formatCurrency(calculateTotal()) }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="appendix-files" class="col-sm-3 col-form-label"> File phụ lục </label>
                <div class="col-sm-9">
                  <div class="custom-file mb-2">
                    <input
                      id="appendix-files"
                      type="file"
                      class="custom-file-input"
                      @change="handleAppendixFilesUpload"
                      accept=".pdf"
                      multiple
                    />
                    <label class="custom-file-label" for="appendix-files">
                      {{ appendixFileLabel }}
                    </label>
                  </div>

                  <!-- Danh sách file đã chọn -->
                  <div
                    v-if="appendixFiles.length > 0"
                    class="appendix-files-section mb-3 bg-light-subtle rounded-3"
                  >
                    <h6 class="file-section-title fw-bold mb-2" style="font-size: 12px">
                      Files sẽ upload
                    </h6>

                    <div class="upload-files-container">
                      <div
                        v-for="(file, index) in appendixFiles"
                        :key="index"
                        class="file-item mb-2 p-3 border border-dashed bg-white rounded-3 shadow-sm d-flex align-items-center justify-content-between"
                      >
                        <div class="d-flex align-items-center flex-grow-1">
                          <i
                            class="bx bxs-file text-primary file-icon me-3"
                            style="font-size: 32px"
                          ></i>

                          <div class="file-info overflow-hidden">
                            <div class="file-name text-truncate fw-medium">{{ file.name }}</div>
                            <div
                              class="file-status small mt-1"
                              :class="{
                                'text-primary': file.status === 'uploading',
                                'text-success': file.status === 'done',
                              }"
                            >
                              <span
                                v-if="file.status === 'uploading'"
                                class="d-flex align-items-center"
                              >
                                <i class="bx bx-loader-alt bx-spin me-1"></i>
                                Đang tải lên...
                              </span>
                              <span
                                v-else-if="file.status === 'done'"
                                class="d-flex align-items-center"
                              >
                                <i class="bx bx-check-circle me-1"></i>
                                Đã tải lên
                              </span>
                              <span v-else class="text-muted"> Chờ tải lên </span>
                            </div>
                          </div>
                        </div>

                        <div class="file-actions ms-2">
                          <button
                            type="button"
                            class="btn btn-sm btn-icon rounded-circle"
                            @click="removeAppendixFile(index)"
                            title="Xóa file"
                          >
                            <i class="bx bx-trash text-danger"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="upload-images" class="col-sm-3 col-form-label">
                  Ảnh chuyển khoản
                </label>
                <div class="col-sm-9">
                  <div class="custom-file mb-2">
                    <input
                      id="upload-images"
                      type="file"
                      class="custom-file-input"
                      @change="handleImagesUpload"
                      accept="image/*"
                      multiple
                    />
                    <label class="custom-file-label" for="upload-images">
                      {{ imageFileLabel }}
                    </label>
                  </div>

                  <!-- Danh sách ảnh đã chọn -->
                  <div v-if="uploadImages.length > 0" class="upload-images-section mb-3">
                    <h6 class="file-section-title fw-bold mb-1" style="font-size: 12px">
                      Ảnh sẽ upload
                    </h6>

                    <div class="image-gallery d-flex flex-wrap">
                      <div
                        v-for="(image, index) in uploadImages"
                        :key="index"
                        class="image-item position-relative m-2"
                        style="width: 100px; height: 100px"
                      >
                        <img
                          :src="image.preview"
                          alt="preview"
                          class="img-thumbnail"
                          style="width: 100%; height: 100%; object-fit: cover"
                        />

                        <button
                          type="button"
                          class="btn btn-sm btn-danger position-absolute"
                          style="
                            top: 5px;
                            right: 5px;
                            width: 24px;
                            height: 24px;
                            padding: 0;
                            border-radius: 50%;
                          "
                          @click="removeImage(index)"
                          title="Xóa ảnh"
                        >
                          <i class="bx bx-x"></i>
                        </button>

                        <div
                          class="image-status small text-center mt-1"
                          :class="{
                            'text-primary': image.status === 'uploading',
                            'text-success': image.status === 'done',
                          }"
                        >
                          <span v-if="image.status === 'uploading'">
                            <i class="bx bx-loader-alt bx-spin"></i>
                          </span>
                          <span v-else-if="image.status === 'done'">
                            <i class="bx bx-check-circle"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-notification" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img
          :src="
            isSuccess
              ? require('@/assets/img/noti-success2.svg')
              : require('@/assets/img/noti-unsuccess2.svg')
          "
          :alt="isSuccess ? 'icon-success' : 'icon-error'"
        />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer>
        <b-button size="sm" variant="light" @click="handleCloseModal"> Đóng </b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import { DeviceService } from '@/services/device.service'

  import { CommonService } from '@/services/common.service'

  export default {
    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        id: this.$route.params.id,
        agentId: this.$route.params.agentId,
        orderCode: '',
        Config,
        listDevice: [],
        formData: {
          agencyCode: '',
          amount: null,
          appendixCode: '',
          receiptDate: '', // Mặc định là ngày hiện tại
          transactionCode: '',
          description: '',
          devices: [],
          uploadImgs: [],
          source: 'NEXT_AGENT',
          purchaseOrderCode: '',
        },
        appendixFiles: [], // Mảng các file phụ lục cần upload
        uploadImages: [], // Mảng các ảnh cần upload
        appendixFileLabel: '(Chọn nhiều file PDF)',
        imageFileLabel: '(Chọn nhiều ảnh)',
        validationErrors: {
          agencyCode: '',
          // amount: '',
          appendixCode: '',
          receiptDate: '',
          transactionCode: '',
          description: '',
          purchaseOrderCode: '',
        },
        notiModal: false,
        msgNoti: '',
        isSuccess: true,
        dataDetail: {},
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    created() {
      this.fetchData()
    },

    methods: {
      validateUnitPrice(index) {
        const item = this.dataDetail.orderDetail[index]
        const unitPriceValue = item.unitPrice
        const fieldKey = `unitPrice_${index}`

        // Xóa thông báo lỗi trước đó
        this.$set(this.validationErrors, fieldKey, '')

        // Nếu không nhập gì thì không validate (vì không bắt buộc)
        if (!unitPriceValue || unitPriceValue.toString().trim() === '') {
          item.unitPrice = null
          return
        }

        // Chuyển đổi thành số
        const numericValue = parseFloat(unitPriceValue)

        // Validate số hợp lệ
        if (isNaN(numericValue)) {
          this.$set(this.validationErrors, fieldKey, 'Vui lòng nhập số hợp lệ')
          item.unitPrice = null
        } else if (numericValue < 0) {
          this.$set(this.validationErrors, fieldKey, 'Đơn giá không được âm')
          item.unitPrice = null
        } else {
          // Hợp lệ - lưu giá trị số
          item.unitPrice = numericValue
        }
      },

      calculateTotal() {
        if (!this.dataDetail.orderDetail || this.dataDetail.orderDetail.length === 0) {
          return 0
        }

        return this.dataDetail.orderDetail.reduce((total, item) => {
          const unitPrice = parseFloat(item.unitPrice) || 0
          const quantity = parseFloat(item.quantity) || 0
          return total + unitPrice * quantity
        }, 0)
      },

      formatCurrency(amount) {
        return new Intl.NumberFormat('vi-VN', {
          style: 'currency',
          currency: 'VND',
        }).format(amount)
      },

      openDatePicker() {
        // Khi người dùng click vào input hoặc biểu tượng lịch
        // Mở bộ chọn ngày bằng cách gọi click() trên input type="date"
        this.$refs.dateInput.showPicker
          ? this.$refs.dateInput.showPicker()
          : this.legacyDatePickerFocus()
      },

      legacyDatePickerFocus() {
        // Phương pháp dự phòng cho các trình duyệt không hỗ trợ showPicker()
        this.$refs.dateInput.focus()

        // Thêm sự kiện click vào input để trigger bộ chọn ngày
        // Tạo một sự kiện mouse event giả
        const clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true,
        })

        // Gửi sự kiện click tới input
        this.$refs.dateInput.dispatchEvent(clickEvent)
      },

      numberOnly(e) {
        // Chỉ cho phép nhập số và dấu chấm cho số thập phân
        const charCode = e.which ? e.which : e.keyCode
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46 // dấu chấm (.) cho số thập phân
        ) {
          e.preventDefault()
        }
      },
      validateAmount() {
        // Xử lý khi người dùng nhập giá trị
        const amountValue = this.formData.amount

        // Chuyển đổi giá trị nhập vào thành số
        const numericValue = parseFloat(amountValue)

        // Xóa thông báo lỗi nếu đã có
        this.validationErrors.amount = ''

        // Nếu giá trị không phải số hợp lệ hoặc âm
        if (isNaN(numericValue)) {
          this.formData.amount = null
          this.validationErrors.amount = 'Vui lòng nhập số hợp lệ'
        } else if (numericValue < 0) {
          this.formData.amount = null
          this.validationErrors.amount = 'Số tiền không được âm'
        } else {
          // Nếu hợp lệ, lưu giá trị đã được chuyển đổi thành số
          this.formData.amount = numericValue
        }
      },
      async fetchData() {
        try {
          this.showLoading = true
          const data = await DeviceService.DetailGetListDeviceOrder({
            id: this.id,
          })

          if (data.success || data.code === 1000) {
            this.listDevice =
              data.data.map(e => ({ name: e.name || e.categoryName, serial: e.serial })) || []
          }

          const resData = await DeviceService.DetailOrderFormPartner({
            id: this.id,
          })

          if (resData.success || resData.code === 1000) {
            this.orderCode = resData.data.orderCode
            this.dataDetail = resData.data

            // // Khởi tạo unitPrice cho mỗi item (thêm dòng này)
            // if (this.dataDetail.orderDetail && this.dataDetail.orderDetail.length > 0) {
            //   this.dataDetail.orderDetail.forEach(item => {
            //     if (!Object.prototype.hasOwnProperty.call(item, 'unitPrice')) {
            //       this.$set(item, 'unitPrice', null);
            //     }
            //   });
            // }
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.showLoading = false
        }
      },
      handleAppendixFilesUpload(event) {
        const files = event.target.files
        if (files && files.length > 0) {
          // Thêm files vào mảng appendixFiles
          for (let i = 0; i < files.length; i++) {
            this.appendixFiles.push({
              file: files[i],
              name: files[i].name,
              status: 'pending',
            })
          }

          // Cập nhật label
          this.appendixFileLabel = `${this.appendixFiles.length} file được chọn`
        } else {
          this.appendixFileLabel = '(Chọn nhiều file)'
        }

        // Reset input để có thể chọn lại file đã chọn trước đó
        event.target.value = ''
      },

      handleImagesUpload(event) {
        const files = event.target.files
        if (files && files.length > 0) {
          // Thêm files vào mảng uploadImages
          for (let i = 0; i < files.length; i++) {
            const file = files[i]
            const reader = new FileReader()

            reader.onload = e => {
              this.uploadImages.push({
                file: file,
                name: file.name,
                status: 'pending',
                preview: e.target.result,
              })
            }

            reader.readAsDataURL(file)
          }

          // Cập nhật label
          this.imageFileLabel = `${files.length} ảnh được chọn`
        } else {
          this.imageFileLabel = '(Chọn nhiều ảnh)'
        }

        // Reset input để có thể chọn lại file đã chọn trước đó
        event.target.value = ''
      },

      removeAppendixFile(index) {
        this.appendixFiles.splice(index, 1)
        this.appendixFileLabel =
          this.appendixFiles.length > 0
            ? `${this.appendixFiles.length} file được chọn`
            : '(Chọn nhiều file)'
      },

      removeImage(index) {
        this.uploadImages.splice(index, 1)
        this.imageFileLabel =
          this.uploadImages.length > 0
            ? `${this.uploadImages.length} ảnh được chọn`
            : '(Chọn nhiều ảnh)'
      },

      // Upload file lên S3
      async uploadFileToS3(fileItem) {
        try {
          const formData = new FormData()
          formData.append('files', fileItem.file)
          formData.append('folderName', 'NextCrm')

          const response = await CommonService.uploadFile(formData)
          if (response && response.data && response.data.length > 0) {
            fileItem.status = 'done'
            return response.data[0]
          }
          return null
        } catch (error) {
          console.error('Upload file error:', error)
          return null
        }
      },
      async uploadImageToS3(fileItem) {
        try {
          const formData = new FormData()
          formData.append('files', fileItem.file)
          formData.append('folderName', 'NextCrm')

          const response = await CommonService.uploadImg(formData)
          if (response && response.data && response.data.length > 0) {
            fileItem.status = 'done'
            return response.data[0]
          }
          return null
        } catch (error) {
          console.error('Upload file error:', error)
          return null
        }
      },

      // Upload tất cả các file phụ lục
      async uploadAllAppendixFiles() {
        const uploadedFiles = []

        // Upload từng file và lưu kết quả
        for (let i = 0; i < this.appendixFiles.length; i++) {
          this.appendixFiles[i].status = 'uploading'
          const result = await this.uploadFileToS3(this.appendixFiles[i])
          if (result) {
            uploadedFiles.push(result)
          } else {
            this.showErrorModal(`Không thể tải lên file: ${this.appendixFiles[i].name}`)
            return null
          }
        }

        return uploadedFiles
      },

      // Upload tất cả các ảnh
      async uploadAllImages() {
        const uploadedImages = []

        // Upload từng ảnh và lưu kết quả
        for (let i = 0; i < this.uploadImages.length; i++) {
          this.uploadImages[i].status = 'uploading'
          const result = await this.uploadImageToS3(this.uploadImages[i])
          if (result) {
            uploadedImages.push(result)
          } else {
            this.showErrorModal(`Không thể tải lên ảnh: ${this.uploadImages[i].name}`)
            return null
          }
        }

        return uploadedImages
      },

      validateForm() {
        let isValid = true

        // Reset all validation errors
        Object.keys(this.validationErrors).forEach(key => {
          this.validationErrors[key] = ''
        })

        // Kiểm tra amount
        // if (!this.formData.amount) {
        //   this.validationErrors.amount = 'Vui lòng nhập số tiền';
        //   isValid = false;
        // } else if (this.formData.amount <= 0) {
        //   this.validationErrors.amount = 'Vui lòng nhập số tiền lớn hơn 0';
        //   isValid = false;
        // }

        if (!this.formData.appendixCode.trim()) {
          this.validationErrors.appendixCode = 'Vui lòng nhập mã phụ lục'
          isValid = false
        }

        return isValid
      },
      async saveData() {
        // Validate form
        if (!this.validateForm()) {
          this.showErrorModal('Vui lòng điền đầy đủ thông tin')
          return
        }

        try {
          this.loading = true

          // Chuẩn bị dữ liệu products từ orderDetail
          const products = this.dataDetail.orderDetail
            ? this.dataDetail.orderDetail.map(item => {
                const unitPrice = parseFloat(item.unitPrice) || 0
                const quantity = parseFloat(item.quantity) || 0
                const amount = unitPrice * quantity // Tổng của 1 loại sản phẩm

                return {
                  name: item.categoryName || item.name || '',
                  amount: amount, // Tổng tiền của loại sản phẩm này
                  price: unitPrice,
                  quantity: quantity,
                }
              })
            : []

          // Tính tổng amount của tất cả sản phẩm
          const totalAmount = products.reduce((sum, product) => sum + product.amount, 0)

          // Upload tất cả file phụ lục nếu có
          let uploadedFiles = []
          if (this.appendixFiles.length > 0) {
            const filesResult = await this.uploadAllAppendixFiles()
            if (!filesResult) {
              this.loading = false
              return
            }
            uploadedFiles = filesResult
          }

          // Upload tất cả ảnh nếu có
          let uploadedImages = []
          if (this.uploadImages.length > 0) {
            const imagesResult = await this.uploadAllImages()
            if (!imagesResult) {
              this.loading = false
              return
            }
            uploadedImages = imagesResult
          }

          // Tạo payload theo cấu trúc API yêu cầu
          const payload = {
            agencyId: this.agentId,
            // amount: this.formData.amount,
            amount: totalAmount,
            appendixCode: this.formData.appendixCode,
            transactionCode: this.formData.transactionCode,
            description: this.formData.description,
            devices: this.listDevice || [], // Chưa rõ cấu trúc, nên để mảng rỗng
            uploadImgs: uploadedImages,
            appendixFiles: uploadedFiles,
            source: 'NEXT_AGENT',
            purchaseOrderCode: this.orderCode,
            products: products,
          }

          // Chuyển đổi receiptDate từ string sang timestamp nếu cần
          if (this.formData.receiptDate) {
            const date = new Date(this.formData.receiptDate)
            payload.receiptDate = date.getTime()
          }
          // Gọi API tạo phiếu thu
          const response = await DeviceService.CreateReceiptAgencys(payload)

          if (response && response.code === 1000) {
            this.showSuccessModal('Tạo phiếu thu thành công')

            // Reset form
            this.formData = {
              agencyCode: '',
              amount: null,
              appendixCode: '',
              receiptDate: new Date().toISOString().substr(0, 10),
              transactionCode: '',
              description: '',
              devices: [],
              uploadImgs: [],
              source: 'NEXT_AGENT',
              purchaseOrderCode: '',
            }

            // Xóa mảng file và ảnh đã upload
            this.appendixFiles = []
            this.uploadImages = []
            this.appendixFileLabel = '(Chọn nhiều file)'
            this.imageFileLabel = '(Chọn nhiều ảnh)'
          } else {
            this.showErrorModal(response?.message || 'Có lỗi xảy ra, vui lòng thử lại sau')
          }
        } catch (error) {
          console.error('Save data error:', error)
          this.showErrorModal('Có lỗi xảy ra, vui lòng thử lại sau')
        } finally {
          this.loading = false
        }
      },

      showSuccessModal(message) {
        this.isSuccess = true
        this.msgNoti = message
        this.notiModal = true
      },

      showErrorModal(message) {
        this.isSuccess = false
        this.msgNoti = message
        this.notiModal = true
      },

      handleCloseModal() {
        this.notiModal = false
        // Nếu thành công, quay về trang danh sách
        if (this.isSuccess) {
          this.$router.push('/order-form')
        }
      },
    },
  }
</script>

<style scoped>
  .card {
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }

  .breadcrumb-area {
    margin-bottom: 20px;
  }

  .breadcrumb-area h1 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 0;
  }

  .btn-group .btn {
    margin-left: 5px;
  }

  .custom-file-label::after {
    content: 'Chọn file';
  }

  .text-danger {
    color: #dc3545 !important;
  }

  .invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
  }

  .is-invalid {
    border-color: #dc3545;
  }

  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
  }

  .btn-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }

  .border-dashed {
    border-style: dashed !important;
  }

  input[type='date']::-webkit-calendar-picker-indicator {
    opacity: 0;
    /* Ẩn icon mặc định nhưng vẫn giữ tính năng */
    width: 100%;
    /* Mở rộng vùng click */
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
  }

  /* Style cho icon lịch tùy chỉnh */
  .bx-calendar {
    color: #666;
    font-size: 1.2rem;
    transition: color 0.2s;
  }

  .bx-calendar:hover {
    color: #007bff;
  }

  /* Sửa lại icon để hiển thị đúng */
  .bx {
    font-family: 'boxicons' !important;
    font-weight: normal;
    font-style: normal;
    display: inline-block;
  }
</style>
